import { settlement } from '@/api/index'

export function getChaufferBillno () {
  return settlement.request({
    method: 'post',
    url: '/GetChaufferBillno'
  })
}
